<template>
    <div :style="{width, height}" class="statisDiv">
        <div class="contentClass">
            <div class="describeClass">{{describeText}}</div>
            <img class="gemstoneClass" src="../src/assets/imgs/gemstoneImg.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        describeText: String
    },
    data(){
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.statisDiv{
    display: flex;
    // flex-direction: column;
    width: 100%;
    height: 100%;
    background-image: url('../src/assets/imgs/rightModelling.png');
    background-size: 100% 100%;
    // background-color: aquamarine;
}
.contentClass{
    display: flex;
    // float: right;
    // right: 18%;
    margin: 0 18% auto auto;
    // background-color: #79beec;
}

.gemstoneClass{
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
}
.describeClass{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    margin-top: 3px;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 20px;    
}
</style>